import { useEffect, useState } from 'react'
import { useStyles } from './file-uploader.styles'
import { toBase64 } from 'lib/utils'
import { Chip, Grid, IconButton, Typography } from '@material-ui/core'
import { DownloadIcon } from 'asterX-UI/Icons/DownloadIcon'
import { DeleteOutline } from '@material-ui/icons'
import { GridCheckIcon } from '@material-ui/data-grid'
import clsx from 'clsx'
import { PhotoIcon } from 'asterX-UI/Icons/PhotoIcon'
import ActionModal from 'asterX-UI/Modals/ActionModal'

export const FileUploader = ({
  accept,
  label,
  placeholder,
  downloadedPlaceholder = '',
  uploadedFile = undefined,
  onChange,
  setUploadedFile
}) => {
  const classes = useStyles()
  const [file, setFile] = useState(uploadedFile)
  const [deleteOpen, setDeleteOpen] = useState(false)

  const handleChange = async e => {
    if (e?.target?.files?.[0]) {
      const file = await toBase64(e?.target?.files[0])

      setFile(file)
      onChange?.(e)
    }
  }

  const handleOpenModal = e => {
    e.preventDefault()
    setDeleteOpen(prev => !prev)
  }

  const downloadFile = async e => {
    e.preventDefault()
    window.open(uploadedFile, '_blank')
  }

  const deleteFile = async () => {
    setUploadedFile(undefined)
    setFile(undefined)
    setDeleteOpen(false)
  }

  useEffect(() => {
    setFile(uploadedFile)
  }, [uploadedFile])

  return (
    <Grid container className={classes.wrapper}>
      {!file && (
        <input
          className={classes.input}
          onChange={handleChange}
          type="file"
          accept={accept}
        />
      )}
      {!!file ? (
        <Grid
          item
          className={classes.uploadedContainer}
          container
          justifyContent={'center'}
        >
          <Grid
            item
            container
            alignItems={'flex-end'}
            justifyContent={'flex-end'}
            spacing={2}
            className={classes.buttonsWrapper}
          >
            <Grid item>
              <IconButton
                className={classes.iconButton}
                onClick={e => downloadFile(e)}
              >
                <DownloadIcon />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton
                className={classes.iconButton}
                onClick={handleOpenModal}
              >
                <DeleteOutline />
                <input className={classes.input} type="file" accept={accept} />
              </IconButton>
            </Grid>
          </Grid>
          <Grid item className={clsx(classes.icon, classes.iconDownloaded)}>
            <GridCheckIcon style={{ width: 20, height: 20 }} />
          </Grid>

          <Grid item xs={12} style={{ marginTop: 16, marginBottom: 36 }}>
            <Typography variant={'body2'} className={classes.placeholder}>
              {downloadedPlaceholder}
            </Typography>
          </Grid>
          <Grid item xs={12} className={classes.labelWrapper}>
            <Typography variant={'body2'} className={classes.label}>
              {label}
            </Typography>
          </Grid>
        </Grid>
      ) : (
        <Grid
          item
          container
          className={classes.fileContainer}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <Grid item className={classes.icon}>
            <PhotoIcon style={{ width: 20, height: 20 }} />
          </Grid>
          <Grid item style={{ marginTop: 16, marginBottom: 36 }}>
            <Typography variant={'body2'} className={classes.placeholder}>
              {placeholder}
            </Typography>
          </Grid>
          <Grid item>
            <Chip
              color={'default'}
              className={classes.chipUpload}
              label={'Загрузить'}
            />
          </Grid>
        </Grid>
      )}
      <ActionModal
        title={'Вы уверены что хотите удалить данный документ?'}
        open={deleteOpen}
        onClose={() => setDeleteOpen(false)}
        onCancel={() => setDeleteOpen(false)}
        onConfirm={deleteFile}
        rootStyles={{ maxWidth: 420 }}
      ></ActionModal>
    </Grid>
  )
}
